import { Ionicons } from '@expo/vector-icons';
import type { ComponentProps } from 'react';

export type FileUploaderIconName = ComponentProps<typeof Ionicons>['name'];

export const FILE_FORMAT_MIME_MAP: Record<string, string[]> = {
  pdf: ['application/pdf'],
  docx: [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
  ],
  doc: ['application/msword'],
  csv: ['text/csv'],
  png: ['image/png'],
  jpeg: ['image/jpeg'],
  jpg: ['image/jpeg'],
  txt: ['text/plain'],
};

export const FILE_TYPE_ICONS: Record<string, FileUploaderIconName> = {
  pdf: 'document-text-outline',
  doc: 'document-text-outline',
  docx: 'document-text-outline',
  csv: 'document-text-outline',
  png: 'image-outline',
  jpg: 'image-outline',
  jpeg: 'image-outline',
  txt: 'document-outline',
};
